module.exports = {
    controller:require('apps/common/viewmodules/spinning-button/controller-spinning-button'),
    view      :require('apps/common/viewmodules/spinning-button/view-spinning-button')
};